const REQUEST_URL =
  "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";

const REQUEST_CONFIG = {
  method: "HEAD",
  mode: "no-cors",
};

export const checkAdsBlocked = async () => {
  try {
    const response = await fetch(REQUEST_URL, REQUEST_CONFIG);
    return response.redirected; // Ads are blocked if request is redirected
  } catch {
    return true; // Ads are considered blocked if request fails
  }
};
